"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
var playlist_1 = require("../../selectors/playlist");
var playlist_2 = require("../../stores/playlist");
var regeneratePlaylist_1 = __importDefault(require("../generation/regeneratePlaylist"));
var queueProgressiveCacheTracks_1 = __importDefault(require("../caching/queueProgressiveCacheTracks"));
var global_1 = require("../../selectors/global");
var player_1 = require("../../stores/player");
var global_2 = require("../../stores/global");
function rotatePlaylist(skipped) {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/rotatePlaylist");
        var settings = _kernel_container_1.default.get("SETTINGS");
        var prevPlaylistItem = (0, playlist_1.selectCurrentPlaylistItem)(getState());
        var shouldRegenerateOnSkip = settings.getSetting("SHOULD_REGENERATE_ON_SKIP", true);
        if (!prevPlaylistItem) {
            logger.warn("Cannot rotate playlist to next track, playlist is empty");
            return;
        }
        var offlinePlaybackLock = selector(getState()).offlinePlaybackLock;
        if (offlinePlaybackLock) {
            dispatch((0, player_1.setCurrentPlayState)(_kernel_store_types_1.EPlayState.STOP));
            logger.warn("Stopping playback, offline playback could not be enabled", {
                offlinePlaybackLock: offlinePlaybackLock,
            });
            return;
        }
        dispatch((0, playlist_2.rotatePlaylistItem)());
        var _a = selector(getState()), currentTrackCached = _a.currentTrackCached, isConnected = _a.isConnected;
        var nextPlaylistItem = (0, playlist_1.selectCurrentPlaylistItem)(getState());
        logger.error("Playlist rotation", {
            prevRotationId: prevPlaylistItem.rotationId,
            prevMediafileId: prevPlaylistItem.mediafileId,
            rotationId: nextPlaylistItem === null || nextPlaylistItem === void 0 ? void 0 : nextPlaylistItem.rotationId,
            mediafileId: nextPlaylistItem === null || nextPlaylistItem === void 0 ? void 0 : nextPlaylistItem.mediafileId,
        });
        if (skipped && shouldRegenerateOnSkip) {
            logger.warn("Triggering regeneration, track skipped");
            dispatch((0, regeneratePlaylist_1.default)());
        }
        logger.info("Current track cache state", {
            offlinePlaybackLock: offlinePlaybackLock,
            currentTrackCached: currentTrackCached,
            isConnected: isConnected,
        });
        if (!currentTrackCached && !isConnected) {
            dispatch((0, global_2.setPlaybackLock)({ offline: true }));
            dispatch((0, player_1.setCurrentPlayState)(_kernel_store_types_1.EPlayState.STOP));
            logger.warn("Stopping playback, online playback not available in offline mode", {
                currentTrackCached: currentTrackCached,
                isConnected: isConnected,
            });
        }
        dispatch((0, queueProgressiveCacheTracks_1.default)());
        dispatch({
            type: rotatePlaylist.type,
            payload: {},
        });
    };
    action.type = "rotatePlaylist";
    return action;
}
exports.default = rotatePlaylist;
rotatePlaylist.type = "rotatePlaylist";
function selector(state) {
    return {
        isConnected: (0, global_1.selectIsConnected)(state),
        currentTrackCached: (0, playlist_1.selectCurrentTrackIsCached)(state),
        offlinePlaybackLock: (0, global_1.selectOfflinePlaybackLock)(state),
    };
}
//# sourceMappingURL=rotatePlaylist.js.map